import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import Business from './business/index/index'
import BusinessPosition from './business/position'
import BusinessBrand from './business/brand'

import Split from './split/index/index'
import SplitDetail from './split/detail'
import SplitRecord from './split/record'

import Evaluate from './evaluate/index'
import Question from './question/index'
import X5 from './X5/index'
const Router = ({ match }) => {
  return (
    <React.Fragment>
      <Route
        path={`${match.path}`}
        exact
        render={() => <Redirect to='/business/business'></Redirect>}></Route>

      <Route exact path={`${match.path}/business`} component={Business}></Route>
      <Route
        exact
        path={`${match.path}/business/position/:id`}
        component={BusinessPosition}></Route>
      <Route exact path={`${match.path}/details/:id`} component={X5}></Route>
      <Route
        exact
        path={`${match.path}/business/brand/:id`}
        component={BusinessBrand}></Route>

      <Route exact path={`${match.path}/split`} component={Split}></Route>
      <Route
        exact
        path={`${match.path}/split/:id`}
        component={SplitDetail}></Route>
      <Route
        exact
        path={`${match.path}/split/record/:id`}
        component={SplitRecord}></Route>
      <Route
        exact
        path={`${match.path}/question/:id`}
        component={Question}></Route>

      <Route exact path={`${match.path}/evaluate`} component={Evaluate}></Route>
    </React.Fragment>
  )
}
export default Router
